export interface ScenicData {
  lineBOS: LineBos[];
  pointBOS: PointBos[];
  pointTypeBOS: PointTypeBos[];
}
interface PointTypeBos {
  icon: string;
  iconIn: string;
  name: string;
  pic: string;
  picIn: string;
  url: string;
  id: number;
  isDetails: number;
  isValid: number;
  scenicId: number;
  sort: number;
}
interface LineBos {
  distance: string;
  estimatedTime: string;
  name: string;
  pic: string;
  synopsis: string;
  id: number;
  isValid: number;
  pointNum: number;
  sort: number;
}
interface PointBos {
  address: string;
  audio: string;
  name: string;
  openHour: string;
  pic: string;
  pointInfo: string;
  id: number;
  latitude: number;
  longitude: number;
  pointTypeId: number;
  is_detail?: number;
}

// 不同颜色的icon
export const iconList = {
  "17": {
    back_icon: require("../../static/images/btn-6.png"),
    list_icon: require("../../static/images/list-icon6.png"),
    line_icon: require("../../static/images/line-icon6.png"),
    marker_bg: require("../../static/images/marker-bg (6).png"),
  },
  "16": {
    back_icon: require("../../static/images/btn-1.png"),
    list_icon: require("../../static/images/list-icon.png"),
    line_icon: require("../../static/images/line-icon.png"),
    marker_bg: require("../../static/images/marker-bg (1).png"),
  },
  "18": {
    back_icon: require("../../static/images/btn-3.png"),
    list_icon: require("../../static/images/list-icon3.png"),
    line_icon: require("../../static/images/line-icon3.png"),
    marker_bg: require("../../static/images/marker-bg (3).png"),
  },
  "20": {
    back_icon: require("../../static/images/btn-4.png"),
    list_icon: require("../../static/images/list-icon4.png"),
    line_icon: require("../../static/images/line-icon4.png"),
    marker_bg: require("../../static/images/marker-bg (4).png"),
  },
  "21": {
    back_icon: require("../../static/images/btn-2.png"),
    list_icon: require("../../static/images/list-icon2.png"),
    line_icon: require("../../static/images/line-icon2.png"),
    marker_bg: require("../../static/images/marker-bg (2).png"),
  },
  "19": {
    back_icon: require("../../static/images/btn-5.png"),
    list_icon: require("../../static/images/list-icon5.png"),
    line_icon: require("../../static/images/line-icon5.png"),
    marker_bg: require("../../static/images/marker-bg (5).png"),
  },
};

// marker点样式
export const box_style =
  "width: 19.2vw;height: 17.6vw;display: flex;flex-direction: column;justify-content: space-between;align-items: center;";
export const img_style =
  "width: 8.533vw;height: 9.867vw;margin: 0 auto 1.067vw;";
export const text_style =
  "min-width: auto;white-space:nowrap;padding: 0 15px;height: 6.667vw;background: white;border-radius: 5.6vw;font-size: 4.533vw;line-height: 6.667vw;color: #537F89;text-align: center;";

// 线路详情数据接口
export interface LineDetail {
  estimatedTime: string;
  lineSynopsis: string;
  name: string;
  distance: any;
  id: number;
  isValid: number;
  sort: number;
  pointNum: number;
  points: Points[];
  imgList: ImgList[];
}
interface ImgList {
  id: number;
  isValid: number;
  lineId: number;
  pic: string;
}

interface Points {
  audio: string;
  name: string;
  pic: string;
  id: number;
  isDetails: number;
  isValid: number;
  latitude: number;
  lineId: number;
  longitude: number;
  pointId: number;
}

export function initLineDetail(res?: LineDetail) {
  const obj = res
    ? res
    : {
        distance: "",
        estimatedTime: "",
        lineSynopsis: "",
        name: "",
        id: 0,
        isValid: 0,
        sort: 0,
        pointNum: 0,
        points: [],
        imgList: [],
      };
  return obj;
}
